module.exports = __webpack_public_path__ + "img/messages-bubble-square-text-alternate.d16cec94.svg";